export default __webpack_public_path__ + "/src/assets/images/arrow-up-right-from-square-teal01.svg";